import { device } from 'app/ui-components/breakpoints';
import { playFontSize } from 'app/ui-components/typography/helpers';
import styled from 'styled-components';

export const StyledTopBarVariants = styled.p`
    margin-bottom: 20px;
    ${playFontSize(1.2)}

    @media ${device.GteSmall} {
        margin-bottom: 0;
        ${playFontSize(1.5)}
    }
`;
